import { render, staticRenderFns } from "./RecipeSvgs.vue?vue&type=template&id=3962511a&"
import script from "./RecipeSvgs.vue?vue&type=script&lang=js&"
export * from "./RecipeSvgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports